export enum Messages{
    LoginSuccess = 'Login successful',
    LoginError = 'Please provide valid credentials',
}